import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocale } from '../../contexts/LocaleContext';
import useHardwareFirstCartUnits from '../../hooks/useHardwareFirstCartUnits';
import CheckoutContext from '../../lib/CheckoutContext';
import useHardwareFirstGiftingOffered from '../../lib/hardwareFirstGifting';
import { formatHardwarePrice } from '../../lib/hardwareFirst';
import { getLocalizedPricing } from '../../lib/util/money';
import { cartActions } from '../../reducers/storeCart';
import { PricingByCurrency } from '../../types';
import HardwareFirstCartItem from '../HardwareFirstCartItem/HardwareFirstCartItem';
import styles from '../StripeCheckout/GiftOptions.module.scss';

interface AmountGiftCardCartItemProps {
  pricingInCents: PricingByCurrency;
  removeCartItem?: () => void;
}

export default function AmountGiftCardCartItem({ pricingInCents, removeCartItem }: AmountGiftCardCartItemProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cart } = useContext(CheckoutContext);
  const unitsInCart = useHardwareFirstCartUnits();
  const offered = useHardwareFirstGiftingOffered();
  const formatters = useLocale();
  const { currency } = formatters;
  const replacedTrackers = 'giftCardStash' in cart && !!cart.giftCardStash;

  return (
    <HardwareFirstCartItem
      price={formatHardwarePrice(getLocalizedPricing(pricingInCents, currency), formatters)}
      giftHead
      thumb={<span aria-hidden="true" className={styles.giftMini} />}
      productName={t('fi_gift_card')}
      variantDescription={t('hardware_first_gift_card_line_detail', { currency })}
      removeCartItem={removeCartItem}
      actionLink={
        replacedTrackers && removeCartItem
          ? {
              label: t('hardware_first_gift_card_send_tracker_instead'),
              onClick: () => dispatch(cartActions.restoreGiftCardStash({ unitsInCart, offered })),
            }
          : undefined
      }
    />
  );
}
